import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VexBreadcrumbsComponent } from 'src/@vex/components/vex-breadcrumbs/vex-breadcrumbs.component';
import { VexSecondaryToolbarComponent } from 'src/@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import { defaultChartOptions } from 'src/@vex/utils/default-chart-options';
import { Order, tableSalesData } from 'src/assets/static-data/table-sales-data';
import { WidgetAssistantComponent } from '../widget-assistant/widget-assistant.component';
import { WidgetQuickLineChartComponent } from '../widget-quick-line-chart/widget-quick-line-chart.component';
import { WidgetQuickValueCenterComponent } from '../widget-quick-value-center/widget-quick-value-center.component';
import { WidgetLargeGoalChartComponent } from '../widget-large-goal-chart/widget-large-goal-chart.component';
import { WidgetTableComponent } from '../widget-table/widget-table.component';
import { WidgetLargeChartComponent } from '../widget-large-chart/widget-large-chart.component';
import { DateTime } from 'luxon';
import { IDashboardMainReportDto } from 'src/core/interfaces/dashboardMainReportDto';
import { DashboardService } from 'src/app/shared/services/dashboard.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'vex-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrl: './main-dashboard.component.scss',
  standalone: true,
  imports: [
    VexSecondaryToolbarComponent,
    VexBreadcrumbsComponent,
    MatButtonModule,
    MatIconModule,
    WidgetAssistantComponent,
    WidgetQuickLineChartComponent,
    WidgetLargeGoalChartComponent,
    WidgetQuickValueCenterComponent,
    WidgetLargeChartComponent,
    WidgetTableComponent,
    TranslateModule,
    CommonModule,
    SharedModule,
    MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        ReactiveFormsModule
  ]
})
export class MainDashboardComponent {
   reportData!: IDashboardMainReportDto;
    customerBalance:string;
    ordersCount:any;
    ordersAmount: any;
  dateFilterForm: FormGroup;
  QuntityTableColumns: TableColumn<any>[] = [];
  amountTableColumns: TableColumn<any>[] = [];
    isLoading=false;

    constructor(private dashboardService: DashboardService,
          private translateService: TranslateService,private fb: FormBuilder
            ) {
               // Initialize form with default date range
               const defaultFromDate = new Date(new Date().getFullYear(), 0, 1);;
               const defaultToDate = new Date();
               
               this.dateFilterForm = this.fb.group({
                 fromDate: [defaultFromDate],
                 toDate: [defaultToDate]
               });
               console.log(this.translateService.instant('ITEM_CODE.TEXT')); // Verify current language
               console.log(this.translateService.instant('MY-PROFILE.TEXT')); // Verify current language


            }

              // Add currency formatter method
  formatCurrency(value: number | string): string {
    if (!value) return '0';
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    return `${numValue.toLocaleString('en-SA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  ngOnInit(): void {
    // Wait for translations to be loaded
    this.translateService.get([
      'ITEM_CODE.TEXT', 
      'ITEM_NAME.TEXT', 
      'COUNT.TEXT',
      'FROM.TEXT',
      'TO.TEXT'
  ]).subscribe(translations => {
      console.log('Translations loaded:', translations);
      this.initializeTableColumns();
 
      // Update form field labels
      const fromDateLabel = translations['FROM.TEXT'];
      const toDateLabel = translations['TO.TEXT'];
    });
              // this.fetchMainReport(new Date('2024-01-01'), new Date('2024-12-31'));
              this.dateFilterForm.valueChanges.subscribe(values => {
                if (values.fromDate && values.toDate) {
                  this.fetchMainReport(values.fromDate, values.toDate);
                }
              });
          
              // Initial data fetch
              this.fetchMainReport(
                this.dateFilterForm.get('fromDate')?.value,
                this.dateFilterForm.get('toDate')?.value
              );
            }
  
    fetchMainReport(from: Date, to: Date): void {
      this.isLoading = true;
      // this.errorMessage = null;
  
      this.dashboardService.getMainReport(from, to).subscribe({
        next: (response) => {
           this.reportData = response.data;
         //  this.customerBalance=data.customerBalance.toString();
         console.log(response)
           console.log(response.data.customerBalance)
         console.log(response.data.customerCrditLimit)
           console.log(response.data.totalOrders)
           console.log(response.data.ordersInfo)
          // console.log(this.reportData.customerBalance)
  
          this.ordersCount = response.data?.ordersInfo?.map( orderInfo=>({
            x:new Date(orderInfo.date),
            y:orderInfo.count
          }))
          const lastDate = this.ordersCount[this.ordersCount.length - 1].x;
          const paddedDate = new Date(lastDate);
          paddedDate.setDate(paddedDate.getDate() + 1);
            // const paddedDate2=new Date(paddedDate);
            // paddedDate2.setDate(paddedDate2.getDate()+1)
           this.ordersCount.push({ x: paddedDate, y: null }); // Add a dummy data point
           //this.ordersCount.push({ x: paddedDate2, y: null }); // Add a dummy data point

          this.ordersAmount = response.data?.ordersInfo?.map( orderInfo=>({
            x:new Date(orderInfo.date), 
            y:orderInfo.amount}))
             this.ordersAmount.push({ x: paddedDate, y: null }); // Add a dummy data point
            // this.ordersAmount.push({ x: paddedDate2, y: null }); // Add a dummy data point

          console.log(this.ordersCount)
          console.log(this.ordersAmount)
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error fetching report:', error);
          // this.errorMessage = 'Failed to fetch report data.';
          this.isLoading = false;
        },
      });
    }
  
  
  
// QuntityTableColumns: TableColumn<any>[] = [
//   {
//    // this.translateService.instant("ARE_YOU_SURE.TEXT"),
//     //label: 'ITEM CODE',
//     label:  this.translateService.instant('ITEM_CODE.TEXT'),
//     property: 'itemCode',
//     type: 'text',
//     cssClasses: ['font-medium']
//   },
//   {
//     label:  this.translateService.instant('ITEM_NAME.TEXT'),
//     property: 'itemName',
//     type: 'text',
//     cssClasses: ['font-medium']
//   },
//   {
//     label:  this.translateService.instant('COUNT.TEXT'),
//     property: 'count',
//     type: 'text',
//     cssClasses: ['text-secondary']
//   },
  
// ];

// amountTableColumns: TableColumn<any>[] = [
//   {
//     label:  this.translateService.instant('ITEM_CODE.TEXT'),
//     property: 'itemCode',
//     type: 'text',
//     cssClasses: ['font-medium']
//   },
//   {
//     label:  this.translateService.instant('ITEM_NAME.TEXT'),
//     property: 'itemName',
//     type: 'text',
//     cssClasses: ['font-medium']
//   },

//   {
//     label:  this.translateService.instant('AMOUNT.TEXT'),
//     property: 'amount',
//     type: 'text',
//     cssClasses: ['text-primary']
//   }
// ];

  

private initializeTableColumns(): void {
  // Initialize quantity table columns
  console.log('Current language:', this.translateService.currentLang);
    
  const itemCodeTranslation = this.translateService.instant('ITEM_CODE.TEXT');
  console.log('Item code translation:', itemCodeTranslation);

  this.QuntityTableColumns = [
    {
      label: itemCodeTranslation || 'Item Code', // Fallback text
      property: 'itemCode',
      type: 'text',
      cssClasses: ['font-medium']
    },
    {
      label: this.translateService.instant('ITEM_NAME.TEXT'),
      property: 'itemName',
      type: 'text',
      cssClasses: ['font-medium']
    },
    {
      label: this.translateService.instant('COUNT.TEXT'),
      property: 'count',
      type: 'text',
      cssClasses: ['text-secondary']
    }
  ];

  // Initialize amount table columns
  this.amountTableColumns = [
    {
      label: this.translateService.instant('ITEM_CODE.TEXT'),
      property: 'itemCode',
      type: 'text',
      cssClasses: ['font-medium']
    },
    {
      label: this.translateService.instant('ITEM_NAME.TEXT'),
      property: 'itemName',
      type: 'text',
      cssClasses: ['font-medium']
    },
    {
      label: this.translateService.instant('AMOUNT.TEXT'),
      property: 'amount',
      type: 'text',
      cssClasses: ['text-primary']
    }
  ];
}  
}
